<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-if="is_open_company"
        v-model="listQuery.member_id"
        placeholder="成员公司"
        clearable
        style="width: 120px"
        class="filter-item"
        size="small"
      >
        <el-option
          v-for="member in memberList"
          :label="member.name"
          :value="member.id"
          :key="member.id"
        />
      </el-select>
      订单时间:
      <el-date-picker
        size="small"
        class="filter-item"
        v-model="dateArr"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <div>
      <el-row :gutter="20">
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="value" :id="'total_sales'">
              {{ data.total_sales || 0 }}
            </div>
            <div class="subtitle">总营业额</div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="value" :id="'today_sales'">
              {{ data.today_sales || 0 }}
            </div>
            <div class="subtitle">今日营业额</div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="value" :id="'yesterday_sales'">
              {{ data.yesterday_sales || 0 }}
            </div>
            <div class="subtitle">昨日营业额</div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="value" :id="'up_rate'">{{ data.up_rate || 0 }}%</div>
            <div class="subtitle">增长率</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="filter-container">
      <el-row :gutter="21">
        <el-col :sm="12" :xs="24">
          <el-card shadow="hover">
            <div class="chart-header">总营业额：￥{{ totalSales }}</div>
            <ChartPostData :data="salesChart"></ChartPostData>
          </el-card>
        </el-col>
        <el-col :sm="12" :xs="24">
          <el-card shadow="hover">
            <div class="chart-header">下单总数：{{ totalOrderNum }}</div>
            <ChartPostData :data="orderNumChart"></ChartPostData>
          </el-card>
        </el-col>
        <!--        <el-col :sm="8" :xs="16">-->
        <!--          <el-card shadow="hover">-->
        <!--            <div class="chart-header">今日下单总额：￥{{todaySales}}</div>-->
        <!--            <ChartPostData :data="todaySalesChart"></ChartPostData>-->
        <!--          </el-card>-->
        <!--        </el-col>-->
        <!--        <el-col :sm="8" :xs="16">-->
        <!--          <el-card shadow="hover">-->
        <!--            <div class="chart-header">昨日下单总额：￥{{yesterdaySales}}</div>-->
        <!--            <ChartPostData :data="yesterdaySalesChart"></ChartPostData>-->
        <!--          </el-card>-->
        <!--        </el-col>-->
        <!--        <el-col :sm="8" :xs="16">-->
        <!--          <el-card shadow="hover">-->
        <!--            <div class="chart-header">近30天下单总额：￥{{thirtySales}}</div>-->
        <!--            <ChartPostData :data="thirtySalesChart"></ChartPostData>-->
        <!--          </el-card>-->
        <!--        </el-col>-->
        <!--        <el-col :sm="8" :xs="16">-->
        <!--          <el-card shadow="hover">-->
        <!--            <div class="chart-header">今日下单数量：{{todayOrderNum}}</div>-->
        <!--            <ChartPostData :data="todayOrderNumChart"></ChartPostData>-->
        <!--          </el-card>-->
        <!--        </el-col>-->
        <!--        <el-col :sm="8" :xs="16">-->
        <!--          <el-card shadow="hover">-->
        <!--            <div class="chart-header">昨日下单数量：{{yesterdayOrderNum}}</div>-->
        <!--            <ChartPostData :data="yesterdayOrderNumChart"></ChartPostData>-->
        <!--          </el-card>-->
        <!--        </el-col>-->
        <!--        <el-col :sm="8" :xs="16">-->
        <!--          <el-card shadow="hover">-->
        <!--            <div class="chart-header">近30天下单数量：{{thirtyOrderNum}}</div>-->
        <!--            <ChartPostData :data="thirtyOrderNumChart"></ChartPostData>-->
        <!--          </el-card>-->
        <!--        </el-col>-->
      </el-row>
    </div>

    <!--    <el-table-->
    <!--        v-loading="listLoading"-->
    <!--        :data="list"-->
    <!--        element-loading-text="Loading"-->
    <!--        border-->
    <!--        fit-->
    <!--        highlight-current-row-->
    <!--        size="small"-->
    <!--    >-->
    <!--      <el-table-column align="center" label="序号" width="95">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.$index+1 }}-->
    <!--          &lt;!&ndash;          {{ scope.row.id }}&ndash;&gt;-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="客户名称" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.name }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="客户ID" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.id }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="今日营业额" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.today_sales }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="昨日营业额" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.yesterday_sales }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="营业总额" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.sales }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="今日下单数" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.today_order_num }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="昨日下单数" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.yesterday_order_num }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="总下单数" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ scope.row.order_num }}-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--      <el-table-column label="退单率%" min-width="110" align="center">-->
    <!--        <template slot-scope="scope">-->
    <!--          {{ (scope.row.refund_order_rate*100).toFixed(2) }}%-->
    <!--        </template>-->
    <!--      </el-table-column>-->
    <!--    </el-table>-->

    <!--    <div class="pagination-container">-->
    <!--      <el-pagination size="small" :current-page="listQuery.page" :page-sizes="[10,20,30, 50]"-->
    <!--                     :page-size="listQuery.limit" :total="total" background-->
    <!--                     layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"-->
    <!--                     @current-change="handleCurrentChange"/>-->
    <!--    </div>-->
    <el-dialog
      title="充值"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="金额" prop="money">
          <el-input v-model="form.money" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="常用信息修改"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form1"
        :rules="rules1"
        :model="form1"
        label-position="left"
        label-width="150px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="购买方名称" prop="buyer_name">
          <el-input v-model="form1.buyer_name" />
        </el-form-item>
        <el-form-item label="购买方纳税人识别号" prop="buyer_taxpayer_no">
          <el-input v-model="form1.buyer_taxpayer_no" />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form1.address" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form1.phone" />
        </el-form-item>
        <el-form-item label="开户行" prop="bank">
          <el-input v-model="form1.bank" />
        </el-form-item>
        <el-form-item label="纳税人资质" prop="taxpayer_qualification_type">
          <el-select v-model="form1.taxpayer_qualification_type">
            <el-option label="小微企业" :value="1" />
            <el-option label="一般纳税人" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票类型" prop="invoicing_type">
          <el-select v-model="form1.invoicing_type">
            <el-option label="普通发票" :value="1" />
            <el-option label="专用发票" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="发送邮箱" prop="email">
          <el-input v-model="form1.email" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form1.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveData1" :loading="btnLoading1"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请输入操作密码"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form2"
        :rules="rules2"
        :model="form2"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="操作密码" prop="password">
          <el-input v-model="form2.password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import uploadList from '@/components/UploadList/index.vue'
import downloadExcel from 'vue-json-excel'
import { CountUp } from 'countup.js'
import ChartPostData from '@/components/ChartPostData'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  components: { downloadExcel, ChartPostData, uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  computed: {
    ...mapState({
      is_open_company: (state) => state.user.is_open_company,
    }),
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      data: {},
      types: [],
      form: {
        app_client_id: undefined,
        money: 0,
      },
      rules: {
        money: [
          { required: true, message: '充值金额不能为空', trigger: 'blur' },
        ],
      },
      btnLoading: false,
      dialogFormVisible1: false,
      dialogStatus1: '',
      textMap1: {
        update: '编辑',
        create: '添加',
      },
      form1: {
        app_client_id: '',
        buyer_name: undefined,
        buyer_taxpayer_no: undefined,
        address: undefined,
        phone: undefined,
        bank: undefined,
        taxpayer_qualification_type: undefined,
        invoicing_type: undefined,
        email: undefined,
        remark: undefined,
      },
      rules1: {
        buyer_name: [
          { required: true, message: '购买方名称不能为空', trigger: 'blur' },
        ],
        buyer_taxpayer_no: [
          {
            required: true,
            message: '购买方纳税人识别号不能为空',
            trigger: 'blur',
          },
        ],
      },
      btnLoading1: false,
      dialogVisible2: false,
      form2: {
        id: '',
        password: undefined,
      },
      rules2: {
        password: [
          { required: true, message: '操作密码不能为空', trigger: 'blur' },
        ],
      },
      currentRow: null,
      currentIndex: null,
      visibleSecrets: [],
      exportLoading: false,
      json_fields: {
        交易时间: {
          field: 'created_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        交易金额: {
          field: 'change',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        余额: {
          field: 'after',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        交易类型: {
          field: 'remark',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        备注: {
          field: 'remark',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        操作人: {
          field: 'system_order_no',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + '系统' + '</p>'
          },
        },
      },
      dateArr: null,
      memberList: [],
      refreshTimer: null,
      salesChart: null,
      orderNumChart: null,
      totalSales: 0,
      totalOrderNum: 0,
      yesterdaySalesChart: null,
      yesterdayOrderNumChart: null,
      yesterdaySales: 0,
      yesterdayOrderNum: 0,
      todaySalesChart: null,
      todayOrderNumChart: null,
      todaySales: 0,
      todayOrderNum: 0,
      thirtySalesChart: null,
      thirtyOrderNumChart: null,
      thirtySales: 0,
      thirtyOrderNum: 0,
    }
  },
  created() {
    this.getMemberList()
    this.getDataCount()
    // this.getList()
    this.startAutoRefresh() // 添加定时器启动

    this.getSalasChart()
    // this.getYesterdaySalasChart()
    // this.getTodaySalasChart()
    // this.getThirtySalasChart()
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer) // 销毁定时器
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0] + ' 00:00:00'
        this.listQuery.end_at = newVal[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
  },
  methods: {
    startAutoRefresh() {
      this.refreshTimer = setInterval(() => {
        this.getDataCount()
      }, 5000)
    },
    handleExport() {
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      listQuery.limit = 9999999999
      return request({
        url: '/api/appClientend/app-client/account-logs',
        method: 'get',
        params: listQuery,
      })
        .then((response) => {
          return response.data.data
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    getSalasChart() {
      request({
        url: '/api/appClientend/dataCount/salasChart',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.salesChart = {
          x: response.data.dates,
          y: [
            {
              name: '总营业额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.orderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '下单总数',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.totalSales = response.data.total_sales
        this.totalOrderNum = response.data.total_order_num
      })
    },
    getYesterdaySalasChart() {
      request({
        url: '/api/appClientend/dataCount/salasChart',
        method: 'get',
        params: {
          app_client_id: this.listQuery.app_client_id,
          start_at: moment()
            .subtract(1, 'day')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment()
            .subtract(1, 'day')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          type: 'hour',
        },
      }).then((response) => {
        this.yesterdaySalesChart = {
          x: response.data.dates,
          y: [
            {
              name: '昨日下单总额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.yesterdayOrderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '昨日下单数量',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.yesterdaySales = response.data.total_sales
        this.yesterdayOrderNum = response.data.total_order_num
      })
    },
    getTodaySalasChart() {
      request({
        url: '/api/appClientend/dataCount/salasChart',
        method: 'get',
        params: {
          app_client_id: this.listQuery.app_client_id,
          start_at: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          type: 'hour',
        },
      }).then((response) => {
        this.todaySalesChart = {
          x: response.data.dates,
          y: [
            {
              name: '今日下单总额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.todayOrderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '今日下单数量',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.todaySales = response.data.total_sales
        this.todayOrderNum = response.data.total_order_num
      })
    },
    getThirtySalasChart() {
      request({
        url: '/api/appClientend/dataCount/salasChart',
        method: 'get',
        params: {
          app_client_id: this.listQuery.app_client_id,
          start_at: moment()
            .subtract(29, 'day')
            .startOf('day')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        },
      }).then((response) => {
        this.thirtySalesChart = {
          x: response.data.dates,
          y: [
            {
              name: '近30天下单总额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.thirtyOrderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '近30天下单数量',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.thirtySales = response.data.total_sales
        this.thirtyOrderNum = response.data.total_order_num
      })
    },
    getDataCount() {
      request({
        url: '/api/appClientend/dataCount/index',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        response.data.up_rate = response.data.up_rate * 100
        const newData = response.data

        // 动画更新数字
        this.animateNumber('total_sales', newData.total_sales)
        this.animateNumber('today_sales', newData.today_sales)
        this.animateNumber('yesterday_sales', newData.yesterday_sales)
        this.animateNumber('up_rate', newData.up_rate)

        this.data = newData

        this.getSalasChart()
        // this.getYesterdaySalasChart()
        // this.getTodaySalasChart()
        // this.getThirtySalasChart()
      })
    },
    animateNumber(field, newValue) {
      const dom = document.getElementById(field)
      if (!dom) return

      const current = parseFloat(this.data[field]) || 0
      const endVal = parseFloat(newValue) || 0

      const options = {
        decimalPlaces: field === 'up_rate' ? 2 : 2,
        suffix: field === 'up_rate' ? '%' : '',
      }

      const countUp = new CountUp(dom, endVal, {
        ...options,
        startVal: current,
      })
      if (!countUp.error) {
        countUp.start()
      } else {
        dom.innerText = endVal
      }
    },
    getMemberList() {
      request({
        url: '/api/appClientend/member/list',
        method: 'get',
        params: null,
      }).then((response) => {
        this.memberList = response.data.data
      })
    },
    openPasswordPrompt(index, row) {
      this.currentRow = row
      this.currentIndex = index
      this.form2.id = row.id
      this.dialogVisible2 = true
    },
    confirmPassword() {
      request({
        url: '/api/appClientend/app-client/get-secret',
        method: 'get',
        params: this.form2,
      }).then((response) => {
        this.$set(this.visibleSecrets, this.currentIndex, true)
        this.list[this.currentIndex].app_id = response.data.app_id
        this.list[this.currentIndex].app_secret = response.data.app_secret
        this.dialogVisible2 = false
      })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/appClientend/dataCount/appClientList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.getDataCount()
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getDataCount()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleDelFilter() {
      this.listQuery = {
        page: 1,
        limit: 10,
      }
      this.getList()
    },
    resetForm() {
      this.form = {
        app_client_id: undefined,
        money: 0,
      }
      this.btnLoading = false
    },
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = Object.assign(
        {
          imgArray: [
            'http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png',
            'http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png',
          ],
        },
        row,
      ) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleRecharge(id) {
      this.resetForm()
      this.form.app_client_id = id
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/appClientend/app-client-recharge/recharge',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    handleUpdate1(row) {
      this.form1 = Object.assign({}, row.app_client_info) // copy obj
      this.form1.app_client_id = row.id
      this.dialogStatus1 = 'update'
      this.dialogFormVisible1 = true
      this.$nextTick(() => {
        this.$refs['form1'].clearValidate()
      })
    },
    saveData1() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.btnLoading1 = true
          request({
            url: '/api/appClientend/app-client/store-info',
            method: 'post',
            data: this.form1,
          })
            .then((response) => {
              this.btnLoading1 = false
              this.dialogFormVisible1 = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading1 = false
            })
        }
      })
    },
    handleStatus(id, isNormal) {
      this.$confirm('此操作将修改客户端状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/appClientend/app-client/change-status',
            method: 'post',
            data: { id: id, is_normal: isNormal },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box-card {
  text-align: center;

  .value {
    color: #546dfe;
    font-weight: bold;
    font-size: 26px;
  }

  .subtitle {
    font-size: 12px;
    color: gray;
    margin-top: 6px;
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  margin-bottom: 20px;
}

::v-deep .el-table .error-row {
  background-color: rgba(255, 0, 0, 0.2);
}

::v-deep .el-date-editor .el-range-separator {
  width: 8%;
}
.chart-header {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>
